"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProviders = exports.getCategories = exports.formatDate = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var getProviders = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(jwt, user, companyId) {
    var _JSON$parse;

    var query, companies, _ref2, usersFinanced, _JSON$parse2, providers, finalArray;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = companyId ? "?companyId=".concat(companyId) : "";
            _context.next = 3;
            return _axios.default.get("".concat(user.is_retailer ? process.env.REACT_APP_PENDING_INVITATIONS : process.env.REACT_APP_READ_PROVIDERS).concat(query), {
              headers: {
                Authorization: jwt
              }
            });

          case 3:
            companies = _context.sent;
            _ref2 = ((_JSON$parse = JSON.parse(companies.data.body || "{}")) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.data) || {}, usersFinanced = _ref2.usersFinanced;
            _JSON$parse2 = JSON.parse(companies.data.body || "{}"), providers = _JSON$parse2.providers;
            finalArray = transformProvidersArray(providers || usersFinanced || []);
            return _context.abrupt("return", finalArray);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getProviders(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.getProviders = getProviders;

var transformProvidersArray = function transformProvidersArray(array) {
  var newArray = [];
  array.forEach(function (element) {
    newArray.push({
      id: element.id_company,
      name: element.trade_name
    });
  });
  return newArray;
};

var getCategories = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(jwt, user, company) {
    var _JSON$parse3;

    var isTHDUser, _ref4, financedRetailers, key, query, response, categories, finalArray;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            isTHDUser = user.is_retailer === 1;
            _ref4 = company || {}, financedRetailers = _ref4.financedRetailers;
            key = financedRetailers ? "financedRetailers" : "retailers";
            query = isTHDUser || key === "financedRetailers" ? "?id=".concat(encodeURIComponent(company[key].map(function (ret) {
              return ret.id;
            }).join(","))) : "";
            _context2.next = 6;
            return _axios.default.get("".concat(process.env.REACT_APP_CATEGORY_ENDPOINT).concat(query), {
              headers: {
                Authorization: jwt
              }
            });

          case 6:
            response = _context2.sent;
            categories = ((_JSON$parse3 = JSON.parse(response.data.body)) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.data) || {};
            finalArray = getCategoriesRecursive(categories);
            return _context2.abrupt("return", finalArray);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getCategories(_x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

exports.getCategories = getCategories;

var formatDate = function formatDate(date) {
  var newDate = new Date(date);
  var year = newDate.getFullYear();
  var month = newDate.getMonth() + 1;
  var day = newDate.getDate();
  return "".concat(year, "/").concat(month, "/").concat(day);
};

exports.formatDate = formatDate;

var getCategoriesRecursive = function getCategoriesRecursive(object) {
  var keys = Object.keys(object);
  return keys.map(function (key, index) {
    var sub_category = object[key].sub_category;

    if (sub_category) {
      return {
        id: index,
        name: key,
        subOptions: getCategoriesRecursive(sub_category)
      };
    } else {
      return {
        id: object[key].id_category,
        name: key
      };
    }
  });
};